import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/medqair.webp';
import screenshot_target from '../../../images/letterfunnel/leondoorn.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Leon Doorn"
      firstname="Leon"
      companyname="MedQAIR"
      competition="Emergo en Qserve"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/leondoorn.js